import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommentaryService } from '../services/commentary.service';
import { ActivatedRoute, Router } from '@angular/router';

//declare var $: any;
@Component({
  selector: 'app-display-commentary',
  templateUrl: './display-commentary.component.html',
  styleUrls: ['./display-commentary.component.less']
})
export class DisplayCommentaryComponent implements OnInit {

  data:any = [];
  subscription: any;
  openCommentaryId: any; //track id of the most recent
  theOpenBody: any;
  id: number;


  constructor(public commentaryService: CommentaryService, public route: ActivatedRoute, private router: Router) { }

  ngOnInit() {

      var controller: any = this;

      this.commentaryService.getCommentary().subscribe(json=>{
          this.data = json;
      },()=>{},
          ()=>{

          this.id = this.route.snapshot.paramMap.get('id') ? this.route.snapshot.paramMap.get('id') : this.data[0].id;

              if (this.route.snapshot.paramMap.get('id')) {
                  controller.openCommentaryId = this.route.snapshot.paramMap.get('id')
                  this.getBody(this.id);
              }
              else{
                  controller.goToNewRoute(controller.id);
              }

          });

  }


  getBody(id){
      this.commentaryService.getCommentaryById(id).subscribe(
          json=>{ this.theOpenBody = json.html;

              this.data.forEach((element)=>{
                  if(element.id == this.openCommentaryId ){
                      element.body = this.theOpenBody;
                  }
              });
          });
  }

    goToNewRoute(id){
      if(this.openCommentaryId == id){return;}

        this.router.navigate(['commentary/' + id]).then(()=>{
            this.openCommentaryId = id;
            this.id = id;
            this.getBody(id);
        });
    }

  ngOnDestroy(){
      if(this.subscription){
          this.subscription.unsubscribe();
      }
  }


}



// WEBPACK FOOTER //
// ./src/app/commentary/display-commentary/display-commentary.component.ts